import React, { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { homeDisplayApi } from "@/modules/homeDisplay/api";
import type { ProtocolContent } from "@/modules/homeDisplay/api";
import "./ProtocolDialog.scss";
import type { ProtocolDialogProps } from "./ProtocolDialog.types";
import { NavBar } from "../Base/NavBar";
import { BackIcon } from "../Icon/IconSvgMap";
import PageLoading from "../PageLoading";
import { Markdown } from "../Markdown/Markdown";

export const ProtocolDialog: React.FC<ProtocolDialogProps> = ({
  visible,
  onClose,
  protocolPath,
}) => {
  const dialogRef = useRef<HTMLDivElement>(null);
  const [loading, setLoading] = useState(false);
  const [protocol, setProtocol] = useState<ProtocolContent | null>(null);
  const [error, setError] = useState<string>("");

  // 加载协议内容
  useEffect(() => {
    if (visible && protocolPath) {
      const loadProtocol = async () => {
        setLoading(true);
        setError("");
        try {
          const data = await homeDisplayApi.getProtocol(protocolPath);
          setProtocol(data);
        } catch (err) {
          console.error("Failed to load protocol:", err);
          setError("Failed to load protocol content");
        } finally {
          setLoading(false);
        }
      };
      loadProtocol();
    }
  }, [visible, protocolPath]);

  // 控制页面滚动
  useEffect(() => {
    if (visible) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [visible]);

  if (!visible) return null;

  const container = document.getElementById("root") || document.body;

  return createPortal(
    <div className="protocol-dialog-overlay" onClick={onClose}>
      <div
        className="protocol-dialog"
        ref={dialogRef}
        onClick={e => e.stopPropagation()}
      >
        <NavBar
          title={protocol?.name || "Loading..."}
          back
          backIcon={<BackIcon />}
          onBack={onClose}
          className="protocol-dialog__navbar"
          // variant="gradient"
          size="xs"
        />

        <div className="protocol-dialog__content">
          {loading && (
            <div className="protocol-dialog__loading">
              <PageLoading />
            </div>
          )}

          {error && (
            <div className="protocol-dialog__error">
              <p>{error}</p>
            </div>
          )}

          {!loading && !error && protocol && (
            <div className="protocol-dialog__html-content">
              <Markdown source={protocol.content} />
            </div>
          )}
        </div>
      </div>
    </div>,
    container
  );
};

export default ProtocolDialog;
